export const navbar = {
  Search: 'Cerca',
  SearchPlaceholder: 'Cosa vuoi ascoltare?',
  Home: 'Home',
  'Your Library': 'La tua Libreria',
  'Collapse your library': 'Comprimi la tua libreria',
  'Expand your library': 'Espandi la tua libreria',
  Language: 'Lingua',
  'Contact me': 'Contattami',
  'Choose a language': 'Scegli una lingua',
};
